// extracted by mini-css-extract-plugin
module.exports = {"campaignReportTableContainer":"CampaignReportTable_campaignReportTableContainer__2jeV6","campaignReportTable":"CampaignReportTable_campaignReportTable__2_I3V"};